import(/* webpackMode: "eager" */ "/vercel/path0/app/meta-tag-generator/page.tsx");
